document.addEventListener("DOMContentLoaded", function () {
  const pdgTopSwiper = new Swiper(".js-pdgPasswordPageSlider", {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
})